import { useContext, useEffect, useState } from "react";
import { AppContext } from "../Context";

function ExtraPrice() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        let lst = [];
        let t = state.fabricPrice;
        lst.push({ item: "Fabric", price: state.fabricPrice });
        if (state.cuffPrice != 0) {
            t += state.cuffPrice;
            lst.push({ item: "Cuff", price: state.cuffPrice });
        }
        if (state.monogramPrice != 0) {
            t += state.monogramPrice;
            lst.push({ item: "Monogram", price: state.monogramPrice });
        }
        if (state.pocketPrice != 0) {
            t += state.pocketPrice;
            lst.push({ item: "Pocket", price: state.pocketPrice });
        }
        if (state.contrastPrice != 0) {
            t += state.contrastPrice;
            lst.push({ item: "Contrast", price: state.contrastPrice });
        }
        if (state.stitchPrice != 0) {
            t += state.stitchPrice;
            lst.push({ item: "Stitch", price: state.stitchPrice });
        }
        if (state.tuxedoPrice != 0) {
            t += state.tuxedoPrice;
            lst.push({ item: "Tuxedo", price: state.tuxedoPrice });
        }
        if (state.placketPrice != 0) {
            t += state.placketPrice;
            lst.push({ item: "Placket", price: state.placketPrice });
        }
        setTotal(t);
        setList(lst);
    }, [state.fabricPattern, state.fabricPrice, state.cuffPrice, state.monogramPrice, state.pocketPrice, state.contrastPrice, state.stitchPrice, state.tuxedoPrice, state.placketPrice]);
    function onClose() {
        dispatch({ type: "SET_SHOW_EXTRA_PAGE", payload: false })
    }
    return (
        <div className="containerEP" style={{ display: state.showExtraPage ? "flex" : "none" }}>
            <div className="epBox">
                <div className="epTitle">Extra Price</div>
                <div className="epList">
                    {list.map((el, index) => (
                        <div key={index} className="portraitExtra">
                            <span>{el.item}</span>
                            <span style={{ padding: "0px 6px" }}>:</span>
                            <span className="extraAmount" style={{ color: "#0000FF", fontSize: "4cqw" }}>${el.price}</span>
                        </div>
                    ))}
                </div>
                <div style={{ display: "flex", justifyContent: "center", fontWeight: 700, paddingBottom: "10px" }}>Total: ${total}</div>
                <img onClick={onClose} style={{ position: "absolute", top: "5px", right: "10px" }} src={process.env.PUBLIC_URL + "/images/close.svg"} />
            </div>
        </div>
    )
}
export default ExtraPrice;